module.exports = __webpack_public_path__ + "static/media/logout_icon_header.50a514f1.svg";